import React from "react";
import { Route } from "react-router-dom";
import BITDSession00 from "../bitd/BITDSession00";
import BITDSession01 from "../bitd/BITDSession01";
import BITDClassesCore from "../bitd/BITDClassesCore";
import BITDOverview from "../bitd/BITDOverview";
import BITDCampaign from "../bitd/campaign/BITDCampaign";
import BITDCampaignDistricts from "../bitd/campaign/BITDCampaignDistricts";
import BITDCampaignDistrictsBarrowcleft from "../bitd/campaign/BITDCampaignDistrictsBarrowcleft";
import BITDCampaignDistrictsBrightstone from "../bitd/campaign/BITDCampaignDistrictsBrightstone";
import BITDCampaignDistrictsCharhollow from "../bitd/campaign/BITDCampaignDistrictsCharhollow";
import BITDCampaignDistrictsCharterhall from "../bitd/campaign/BITDCampaignDistrictsCharterhall";
import BITDCampaignDistrictsCoalridge from "../bitd/campaign/BITDCampaignDistrictsCoalridge";
import BITDCampaignDistrictsCrowsFoot from "../bitd/campaign/BITDCampaignDistrictsCrowsFoot";
import BITDCampaignDistrictsDocks from "../bitd/campaign/BITDCampaignDistrictsDocks";
import BITDCampaignDistrictsDunslough from "../bitd/campaign/BITDCampaignDistrictsDunslough";
import BITDCampaignDistrictsNightmarket from "../bitd/campaign/BITDCampaignDistrictsNightmarket";
import BITDCampaignDistrictsSilkshore from "../bitd/campaign/BITDCampaignDistrictsSilkshore";
import BITDCampaignDistrictsSixTowers from "../bitd/campaign/BITDCampaignDistrictsSixTowers";
import BITDCampaignDistrictsWhitecrown from "../bitd/campaign/BITDCampaignDistrictsWhitecrown";

const BladesInTheDarkRoutes = () => {
  return [
    <Route path="/blades-in-the-dark-session-00" element={<BITDSession00 />} />,
    <Route path="/blades-in-the-dark-session-01" element={<BITDSession01 />} />,

    <Route
      path="/blades-in-the-dark-classes-core"
      element={<BITDClassesCore />}
    />,
    <Route path="/blades-in-the-dark-overview" element={<BITDOverview />} />,
    <Route
      path="/blades-in-the-dark-campaign-introduction"
      element={<BITDCampaign />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts"
      element={<BITDCampaignDistricts />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-barrowcleft"
      element={<BITDCampaignDistrictsBarrowcleft />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-brightstone"
      element={<BITDCampaignDistrictsBrightstone />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-charhollow"
      element={<BITDCampaignDistrictsCharhollow />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-charterhall"
      element={<BITDCampaignDistrictsCharterhall />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-coalridge"
      element={<BITDCampaignDistrictsCoalridge />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-crowsfoot"
      element={<BITDCampaignDistrictsCrowsFoot />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-docks"
      element={<BITDCampaignDistrictsDocks />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-dunslough"
      element={<BITDCampaignDistrictsDunslough />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-nightmarket"
      element={<BITDCampaignDistrictsNightmarket />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-silkshore"
      element={<BITDCampaignDistrictsSilkshore />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-six-towers"
      element={<BITDCampaignDistrictsSixTowers />}
    />,
    <Route
      path="/blades-in-the-dark-campaign-districts-whitecrown"
      element={<BITDCampaignDistrictsWhitecrown />}
    />,
  ];
};

export default BladesInTheDarkRoutes;
